<template>
<v-app>
   <nav>
   <v-toolbar>
     <v-toolbar-title class="headline text-uppercase">
                      <v-app-bar-nav-icon  @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

     </v-toolbar-title>
                 <v-spacer></v-spacer>

            <img src="/inovatiq_logo.png" style="width: 157px; height:46px;">

     <v-spacer></v-spacer>

             <v-btn class="mx-2" fab dark small color="black" href="/logout">
      <v-icon dark>mdi-logout</v-icon>
    </v-btn>


   </v-toolbar>
 </nav>

     <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list-item>

      <img class = "logo pr-4" src="/logo.png">
        ONE
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>

        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>


        <v-sheet color="#376DE7" height="25px"></v-sheet>


     <router-view/>


</v-app>

</template>

<script>

export default {


   data: function () {
    return {
      drawer: null,
      name: localStorage.getItem('name'),
      items: [
          { title: 'Dashboard', icon: 'mdi-google-analytics', link: '/'},   
          {title: 'New Post' , icon: 'mdi-google-analytics', link: '/content'},
           {title: 'Posts' , icon: 'mdi-google-analytics', link: '/posts'},
                           {title: 'AI' , icon: 'mdi-google-analytics', link: '/ai'}


        ],
    }
   },
   created: function (){

     if(localStorage.getItem('permission') == "admin"){
       this.items = [
        { title: 'Dashboard', icon: 'mdi-google-analytics', link: '/'},   
        {title: 'Admin' , icon: 'mdi-google-analytics', link: '/admin'},
        {title: 'New Site' , icon: 'mdi-google-analytics', link: '/newsite'},
        {title: 'New Post' , icon: 'mdi-google-analytics', link: '/content'},
        {title: 'Posts' , icon: 'mdi-google-analytics', link: '/posts'},
                {title: 'AI' , icon: 'mdi-google-analytics', link: '/ai'}


       ]
     }else if(localStorage.getItem('permission') == "freelancer"){
        this.items = [
        {title: 'New Post' , icon: 'mdi-google-analytics', link: '/content'},
        {title: 'Posts' , icon: 'mdi-google-analytics', link: '/posts'}

       ]
     }

   },
   methods: {

   }
}
</script>

<style>
.bg-navbar{
background-color: #2a2a72;
background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%);

}
.logo{
    width: 55px;
    height: 40px;
}
</style>
